export const SCREENS = Object.freeze({
  RENDER_VS_WELCOME_SCREEN: "showVsWelcomeScreen",
  RENDER_NEED_PERMISSIONS_SCREEN: "showNeedPermissionsScreen",
  RENDER_ASSESSMENT_LANG_SCREEN: "showAssessmentLangScreen",
  RENDER_SPLASH_LOADING_SCREEN: "showSplashLoadingScreen",
  RENDER_ORF_TEST_SCREEN: "showOrfTestScreen",
  RENDER_START_READING_SCREEN:"showStartReadingScreen",
  RENDER_ORF_RESULT_SCREEN:"showOrfResultScreen",
  RENDER_ORF_RESULT_LOADINGSCREEN:"showResultLoadingScreen",
});
